import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

interface ActionProps extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
  tone?: "primary" | "secondary" | "text";
}

export function Action({ children, tone = "primary", className = "", ...props }: ActionProps) {
  return (
    <button className={`action action--${tone} ${className}`.trim()} {...props}>
      <span>{children}</span>
      {tone === "primary" ? <span aria-hidden="true">→</span> : null}
    </button>
  );
}
